module.exports = __webpack_public_path__ + "static/media/niv.c07ed816.jpg";